import { IPaginationDTO } from '@/dtos';
import { EmailTemplateDTO, IEmailTemplateDTO } from '@/dtos/email.template.dto';
import { generatePagination, get, post } from '../apiWrapper';

export const getAllEmailTemplatesAPI = async (
  pagination: IPaginationDTO,
): Promise<{ data: IEmailTemplateDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const templates = await get<{ data: IEmailTemplateDTO[]; count: number }>(
    `/admin/email/templates${pageOptions}`,
  );
  return templates;
};

export const getEmailTemplateByIdAPI = async (
  emailTemplateId: string,
): Promise<IEmailTemplateDTO> => {
  const templates = await get<IEmailTemplateDTO>(`/admin/email/templates/${emailTemplateId}`);
  return templates;
};

export const updateEmailTemplateAPI = async (
  emailTemplateId: string,
  emailTemplate: EmailTemplateDTO,
): Promise<IEmailTemplateDTO> => {
  const templates = await post<IEmailTemplateDTO>(
    `/admin/email/templates/${emailTemplateId}/save`,
    emailTemplate,
  );
  return templates;
};
